import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import useValidateMeterRow from '@/features/portfolio-analysis/components/data-integrity/useValidateMeterRow';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { openDialog } from '@/features/portfolio-analysis/redux/dataIntegritySlice';

const DataIntegrityButton = ({ row }) => {
  const dispatch = useDispatch();
  const handleOpenDataIntegrityDialog = useCallback(
    (row) => {
      // Dispatch action to open dialog
      dispatch(openDialog(row));
    },
    [dispatch],
  );
  const validateMeter = useValidateMeterRow();
  const warnings = validateMeter(row);
  return (
    <Badge
      overlap="circular"
      badgeContent={
        warnings.length > 0 ? (
          <WarningRoundedIcon sx={{ fontSize: '15px' }} color="warning" />
        ) : null
      }
    >
      <IconButton
        onClick={(e) => {
          handleOpenDataIntegrityDialog(row);
          e.stopPropagation();
        }}
      >
        <TroubleshootIcon sx={{ cursor: 'pointer', marginLeft: 1 }} />
      </IconButton>
    </Badge>
  );
};

export default DataIntegrityButton;
